export const Theme: Record<string, string> = {
  ColorBackgroundPrimary: '#f2f5f7',
  ColorBackgroundSecondary: '#fff',
  ColorBackgroundWithLogo: '#fff',
  ColorPrimary: '#ee4d2d',
  ColorLink: '#1370f2',
  ColorError: '#ee2c4c',
};

export default Theme;
